/**
 * SignInButton Component
 * Renders a sign-in link/button that redirects to Cognito authentication
 * Hidden when user is authenticated
 */

import { useAuthContext } from '../../contexts/AuthContext';

/**
 * SignInButton component
 * Displays a sign-in link that redirects to Cognito for authentication
 * Automatically hidden when user is authenticated
 * 
 * @returns Sign-in button component or null if authenticated
 */
export function SignInButton() {
  const { isAuthenticated, signIn, isLoading } = useAuthContext();

  // Hide when authenticated or loading
  if (isAuthenticated || isLoading) {
    return null;
  }

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        signIn();
      }}
      aria-label="Sign in with Google"
      style={{
        color: 'var(--color-fg)',
        textDecoration: 'none',
        transition: 'color 0.2s'
      }}
    >
      Sign In
    </a>
  );
}
